<template>
  <div>
    <Head title="Clientes" />
    <h1 class="mb-8 text-3xl font-bold">Clientes</h1>
    <div class="space-y-4 md:space-y-0 md:flex md:items-center md:justify-between mb-6">
      <div class="flex items-center justify-between md:w-auto md:mr-4">
        <div class="flex items-center">
          <span class="mr-2 text-sm">Mostrar</span>
          <select v-model="form.perPage" class="form-select text-sm" @change="updatePerPage">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <Link class="btn-sky text-sm md:hidden" href="/clients/create">
          <span>Agregar</span>
        </Link>
      </div>
    
      <div class="md:flex-grow md:mx-4">
        <search v-model="form.search" class="w-full" @reset="reset" />
      </div>

      <Link class="btn-sky hidden md:inline-flex md:whitespace-nowrap" href="/clients/create">
        <span>Agregar</span>
        <span class="hidden md:inline">&nbsp;Cliente</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-2">Código</th>
          <th class="pb-4 pt-6 px-2">Descripción</th>          
          <th class="pb-4 pt-6 px-2">Tipo</th>          
          <th class="pb-4 pt-6 px-2">Lista precios</th>
          <th class="pb-4 pt-6 px-2">Descuentos</th>
          <th class="pb-4 pt-6 px-2">Encargado</th>
          <th class="pb-4 pt-6 px-2">Latitud</th>
          <th class="pb-4 pt-6 px-2">Longitud</th>
          <th class="pb-4 pt-6 px-2">Acciones</th>
        </tr>
        <tr v-for="client in clients.data" :key="client.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
          <td class="border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`"> 
              {{ client.codigo }}   
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ client.descripcion }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ getTypeClient(client.type) }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ getClientList(client.list_prices) }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ getDiscountsList(client.descuento) }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ client.encargado }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ client.lat }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`">
              {{ client.long }}
            </Link>
          </td>
          <td class="w-px border-t text-center">
            <button class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5" @click="removeClient(client.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3zm0 5h2v9H9zm4 0h2v9h-2z"/></svg>
            </button>
          </td>
          <td class="w-px border-t" /><td class="w-px border-t">
            <Link class="flex items-center px-2 py-4" :href="`/clients/${client.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>                                                   
        </tr>
        <tr v-if="clients.data.length === 0">
          <td class="px-2 py-4 border-t" colspan="14">No se encontraron clientes.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="clients.links" />
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import Swal from 'sweetalert2'
  
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Search,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    clients: Array,
    categories: Object,
    clientTypes:Object,
    clientCategories: Array, 
    codes: Object,  
    listPrices: Array, 
    discounts:Array
  },
  remember: 'form',
  data() {
    return {
      form: {
        search: this.filters.search,
        code: this.filters.code,
        perPage: this.filters.perPage || '10',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/clients', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    updatePerPage() {
      this.$inertia.get('/clients', pickBy(this.form), { preserveState: true })
    },
    getCategoryDescription(number) {
      const category = this.clientCategories.find(cat => cat.id == number)
      return category ? category.description : 'Categoría no disponible'
    },
    getClientList(number) {
      const lista = this.listPrices.find(cat => cat.id == number)
      return lista ? lista.description : 'Lista no disponible'
    },
    getTypeClient(number){
      const typeClient = this.clientTypes.find(obj => obj.id == number)
      return typeClient ? typeClient.description : 'Tipo no disponible'
    },
    getDiscountsList(number) {
      const discount = this.discounts.find(cat => cat.id == number)
      return discount ? discount.name : 'Lista no disponible'
    },
    removeClient(idClient){
      Swal.fire({
        title:'Deshabilitar cliente',
        text:'¿Desea deshabilitar al cliente?',
        icon:'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Deshabilitar',
      }).then((result)=>{
        if(result.isConfirmed){
          this.$inertia.put(`/clients/${idClient}/delete`)
        }
      })
    }, 
  },

}
</script>